import axios from 'axios'
import {
  ScPaymentOption,
  ScSupplyOption,
  SubcontractAgreement,
  PostSubcontractAgreement,
  UpdateSubcontractAgreement,
} from './interfaces'

const apiURL = process.env.REACT_APP_API_URL

const authHeaders = () => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  }
}

// GET: /SubcontractAgreement/supply-options
export const getScSupplyOptions = async (): Promise<ScSupplyOption[]> => {
  const response = await axios({
    url: `https://${apiURL}/SubcontractAgreement/supply-options`,
    method: 'get',
    headers: authHeaders(),
  })

  const data: ScSupplyOption[] = response.data
  return data
}

// GET: /SubcontractAgreement/payment-options
export const getScPaymentOptions = async (): Promise<ScPaymentOption[]> => {
  const response = await axios({
    url: `https://${apiURL}/SubcontractAgreement/payment-options`,
    method: 'get',
    headers: authHeaders(),
  })

  const data: ScPaymentOption[] = response.data
  return data
}

// GET: /SubcontractAgreement/job/{jobId}
export const getSubcontractAgreementsByJob = async (
  jobId: number
): Promise<SubcontractAgreement[]> => {
  const response = await axios({
    url: `https://${apiURL}/SubcontractAgreement/job/${jobId}`,
    method: 'get',
    headers: authHeaders(),
  })

  const data: SubcontractAgreement[] = response.data
  return data
}

// GET: /SubcontractAgreement/{id}/pdf
// Fetched as a blob on the user's token rather than linked to directly - the
// API streams it out of blob storage, so the document is never exposed by a
// public or time-limited URL.
export const getSubcontractAgreementPdf = async (
  subcontractAgreementId: number
): Promise<Blob> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/SubcontractAgreement/${subcontractAgreementId}/pdf`,
    method: 'get',
    responseType: 'blob',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })

  return response.data as Blob
}

// POST: /SubcontractAgreement
export const createSubcontractAgreement = async (
  agreement: PostSubcontractAgreement
): Promise<SubcontractAgreement> => {
  const response = await axios({
    url: `https://${apiURL}/SubcontractAgreement`,
    method: 'post',
    data: agreement,
    headers: authHeaders(),
  })

  const data: SubcontractAgreement = response.data
  return data
}

// PUT: /SubcontractAgreement/{id}
export const updateSubcontractAgreement = async (
  agreement: UpdateSubcontractAgreement
): Promise<SubcontractAgreement> => {
  const response = await axios({
    url: `https://${apiURL}/SubcontractAgreement/${agreement.subcontractAgreementId}`,
    method: 'put',
    data: agreement,
    headers: authHeaders(),
  })

  const data: SubcontractAgreement = response.data
  return data
}

// DELETE: /SubcontractAgreement/{id}
export const deleteSubcontractAgreement = async (
  subcontractAgreementId: number
): Promise<void> => {
  await axios({
    url: `https://${apiURL}/SubcontractAgreement/${subcontractAgreementId}`,
    method: 'delete',
    headers: authHeaders(),
  })
}
